import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceList } from '../../../models/pricelist.model';
import { MoreInfoListComponent } from '../more-info-list/more-info-list.component';
import { NameAndPrice } from '../../../models/types';

@Component({
  standalone: true,
  imports: [CommonModule, MoreInfoListComponent],
  selector: 'lx-price-lists-portal-alp-more-info',
  templateUrl: './alp-more-info.component.html',
  styleUrls: ['./alp-more-info.component.scss'],
})
export class AlpMoreInfoComponent implements OnInit {
  @Input() priceList!: PriceList;

  tuitionUpgradesAndAddOns: NameAndPrice[] = [];
  privateLessons: NameAndPrice[] = [];
  workExperience: NameAndPrice[] = [];
  volunteering: NameAndPrice[] = [];

  ngOnInit(): void {
    this.tuitionUpgradesAndAddOns = this.priceList.addOns?.map(({ name, price }) => ({ name, price }));
    this.privateLessons = this.priceList?.privateLessons?.reduce((items, privateLesson) => {
      const lessonsItems = privateLesson.lessons?.reduce((lessons, { name, price }) => [...lessons, { name, price }], []);
      return [...items, ...lessonsItems];
    }, []);
    this.workExperience = this.priceList.workExperience?.map((workExperice) => ({ name: workExperice }));
    this.volunteering = this.priceList.volunteering?.map((volunteering) => ({ name: volunteering }));
  }
}
